import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { Item, SuccessPopUp } from '../../common/snippets'
import DropDownOA from '../../common/dropDownOA'
import { getHeaderColumnsUserAutoDeactivate } from './constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import TableCellTooltip from '../../common/TableCellTooltip'
import { useTheme } from "@mui/material/styles";
import { getAutoDeactivateUserTblData, updateAutoDeactivateUserData, getADUCategoryData } from '../../../store/branchAndUserMaster/BUMAction'
import { updateAlertError } from '../../../store/common/common_action'
import { connect } from 'react-redux'
import { focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import moment from 'moment'
import SuccessAndErrorModal from '../../common/SuccessAndErrorModal copy'
import { useTranslation } from '../../../i18n/I18nProvider'

const AutoDeactivateUser = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const headerColumnsUserAutoDeactivate = getHeaderColumnsUserAutoDeactivate(translations)
    const { data, updateAutoDeactivateUserData, getAutoDeactivateUserTblData, getADUCategoryData, updateAlertError,loginData } = props
    const {  branchAndUserMasterReducer } = data
    const { autoDeactivateUserTblData, aduCategoryData } = branchAndUserMasterReducer
    const statusList = [
        { id: 0, name: bum.inActive || 'InActive' },
        { id: 1, name: bum.active || 'Active' },
        { id: -1, name: bum.all || 'All' },
    ]
    const [tableData, setTableData] = useState([])
    const [categoryList, setCategoryList] = useState([])
    const [category, setCategory] = useState('')
    const [policyStatus, setPolicyStatus] = useState(statusList[1])
    useEffect(() => {
        if (translations) {
            const currentPolicyStatus = statusList.find(opt => opt.id === policyStatus?.id);
            if (currentPolicyStatus) setPolicyStatus(currentPolicyStatus);
            
            if (category?.id === 0) {
                setCategory({ id: 0, name: bum.all || "All" });
            }
        }
    }, [translations]);
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [manageFocus, setManageFocus] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [editData, setEditData] = useState({ index: '', row: '' })
    const [isSuccess, setIsSuccess] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const theme = useTheme()

    useEffect(() => {
        setTimeout(() => {
            focusElemnt('aduCategoryName')
        }, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        if ((loginData?.intCompanyID!=='undefined')) {
            getCategoryList()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    useEffect(() => {
        if ((loginData?.intCompanyID!=='undefined')) {
            const object = {
                CompanyID: loginData?.intCompanyID,
                RoleID: 0,
                IsActive: -1
            }
            getAutoDeactivateUserTblData(object)
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    const getTableData = () => {
        const object = {
            CompanyID: loginData?.intCompanyID,
            RoleID: category?.id,
            IsActive: -1
        }
        getAutoDeactivateUserTblData(object)
    }
    const getCategoryList = () => {
        const object = {
            CompanyID: loginData?.intCompanyID,
            RoleID: 0,
            IsActive: -1
        }
        getADUCategoryData(object, true, 24 * 60 * 60 * 1000)
    }
    useEffect(() => {
        if (aduCategoryData?.length > 0) {
            var categories = [{ id: 0, name: bum.all || 'All' }]
            aduCategoryData.map((obj) => (
                categories.push({
                    id: obj.RoleID,
                    name: obj.RoleName,
                })
            ))
            categories = removeDuplicatesFromArray(categories, `id`)
            setCategoryList(categories)
            setCategory(categories[0])
        } else {
            setCategoryList([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aduCategoryData])
    useEffect(() => {
        if (autoDeactivateUserTblData?.length > 0) {
            const data = [...autoDeactivateUserTblData]
            let tempData = []
            if (policyStatus?.id === 0) {
                tempData = data.filter((val) => val.IsDeActivateUserAfterExpiryDays === 0)
                tempData.sort((a, b) => {
                    return a.RoleName.localeCompare(b.RoleName);
                });
            } else if (policyStatus?.id === 1) {
                tempData = data.filter((val) => val.IsDeActivateUserAfterExpiryDays === 1)
                tempData.sort((a, b) => {
                    return a.RoleName.localeCompare(b.RoleName);
                });
            } else {
                tempData = data.sort((a, b) => {
                    if (a.IsDeActivateUserAfterExpiryDays === b.IsDeActivateUserAfterExpiryDays) {
                        return a.RoleName.localeCompare(b.RoleName)
                    }
                    return b.IsDeActivateUserAfterExpiryDays - a.IsDeActivateUserAfterExpiryDays
                })
            }
            let newData = tempData?.map((val, i) => ({ ...val, editBtn: true, expiryDays: val.ExpiryDaysToDeactivateUser, deActive: val.IsDeActivateUserAfterExpiryDays }))
            setTableData(newData)
        } else {
            setTableData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoDeactivateUserTblData])

    useEffect(() => {
        setfilteredData(tableData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData])

    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return headerColumnsUserAutoDeactivate.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues])

    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const handleHideEditBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            for (let i = 0; i < newVal?.length; i++) {
                if (i === index) {
                    newVal[i].editBtn = !newVal[i].editBtn
                } else {
                    newVal[i].editBtn = true
                }
            }
            setfilteredData(newVal)
            focusElemnt(`editBtn-${index + 1}`)
            newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
        }
    }
    const handleCrossBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].expiryDays = filteredData[index].ExpiryDaysToDeactivateUser
            newVal[index].deActive = filteredData[index].IsDeActivateUserAfterExpiryDays
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
            setTimeout(() => {
                focusElemnt(`editBtn-${index + 1}`)
            }, 0)
        }
    }
    const handleRowEdit = (row, index) => {
        if (row?.expiryDays === '') {
            updateAlertError({ show: true, msg: bum.pleaseEnterTheNumberOfDaysToDeActivateTheUsersNl || 'Please Enter The Number Of Days\n To De-Activate The Users', success: false, nextId: `aduExpiryDays-${editData?.index}` })
            return
        } else {
            let obj = {
                RoleID: editData?.row?.RoleID,
                CompanyID: loginData?.intCompanyID,
                IsActive: editData?.row?.deActive,
                intDays: editData?.row?.expiryDays,
                UserID: loginData?.intUserID
            }
            updateAutoDeactivateUserData(obj)?.then((res) => {
                if (res?.status === 'success') {
                    setIsSuccess(true)
                } else {
                    updateAlertError({ show: true, msg: res.Message, success: false, nextId: `aduCategoryName` })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }
    const handleRowChkChange = (e, index) => {
        setManageFocus(false)
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].deActive = e.target.checked ? 1 : 0
            setfilteredData(newVal)
        }
        setTimeout(() => {
            focusElemnt(`chkbox-${index}`)
        }, 0)
    }
    const handleInputChange = (e, index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].expiryDays = e.target.value.replace(/[^0-9]/g, '')
            setfilteredData(newVal)
        }
    }
    const ShowAutoDeActivateUserConfirmation = () => {
        const data = {
            successMessage: bum.doYouWantToUpdateThePolicyStatusQ || 'Do you want to update the Policy Status?',
            otherMessage: '',
            buttonId1: '',
            buttonId2: '',
            headTxt: bum.autoDeActivateUsers || 'Auto De-Activate Users',
            yesAction: () => { handleRowEdit(editData?.row, editData?.index); setShowConfirmation(false) },
            noAction: () => setShowConfirmation(false)
        }
        return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
    }

    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell key={`sn-${index}`} style={{ height: '36px', textAlign: 'right', fontSize: '12px', color: '#444444' }}>{index + 1}</TableCell>
                <TableCell key={`rolename-${index}`} style={{ textAlign: 'left', fontSize: '12px', color: '#444444', maxWidth: '106px' }}>{item.RoleName}</TableCell>
                <TableCellTooltip maxWidth={`200px`} title={item.Description || ''} data={item.Description} />

                <TableCell key={`modUserName-${index}`} style={{ textAlign: 'left', fontSize: '12px', color: '#444444', maxWidth: '106px' }}>{item.ModifiedByUserName}</TableCell>
                <TableCellTooltip maxWidth={`180px`} title={item.ModifiedByBranchName || ''} data={item.ModifiedByBranchName} />
                <TableCell key={`dateTime-${index}`} style={{ textAlign: 'left', fontSize: '12px', color: '#444444' }}>{moment(item.ModifiedDatetime).format('HH:mm, DD-MMM-YY')}</TableCell>
                {item.editBtn ? <TableCell key={`expiryDays-${index}`} style={{ textAlign: 'right', fontSize: '12px', color: '#444444' }}>{item.expiryDays}</TableCell> :
                    <TableCell key={`modExpDays-${index}`} >
                        <input
                            id={`aduExpiryDays-${index}`}
                            name={`aduExpiryDays-${index}`}
                            className='input--style'
                            autoFocus={manageFocus}
                            style={{ fontSize: "12px", height: '22px', color: '#444444', textAlign: 'right' }}
                            value={item.expiryDays}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => { navigation1(e, `chkbox-${index}`, `xMark-${index}`) }}
                        />
                    </TableCell>
                }
                <TableCell key={`activeChk-${index}`} style={{ textAlign: 'center', fontSize: '12px', color: '#444444' }}>
                    <Checkbox
                        id={`chkbox-${index}`}
                        checked={item.deActive === 1}
                        onChange={(e) => item.editBtn ? "" : handleRowChkChange(e, index)}
                        sx={{ padding: '0', borderRadius: '0' }}
                        onKeyDown={(e) => {
                            navigation1(e, `checkMark-${index}`, `aduExpiryDays-${index}`)
                        }}
                    />
                </TableCell>
                <TableCell key={`edit-cell-${index}`} style={{ textAlign: 'center', fontSize: '12px', color: '#444444' }}>
                    {item.editBtn ? (
                        <span
                            id={`editBtn-${index}`}
                            tabIndex={0}
                            style={{
                                display: 'flex',
                                width: '52px',
                                color: theme.palette.primary.main,
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '2px 2px',
                                justifyContent: 'center',
                                textAlign: 'center',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            onClick={() => { handleHideEditBtn(index) }}
                            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'aduCategoryName' : `editBtn-${index + 1}`, index === 0 ? "aduLoadBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
                        >
                            <EditIcon sx={{ marginRight: '3px' }} />
                            {bum.edit || 'Edit'}
                        </span>
                    ) :
                        <div key={`check-cross-${index}`} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center' }}>
                            <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                                onClick={() => { setEditData({ index: index, row: item }); setShowConfirmation(true) }}
                                style={{ margin: '0px 4px', width: '25px', padding: '1px 2px', height: '25px', marginTop: '-4px', display: 'flex', justifyContent: 'center' }}
                                onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => { setEditData({ index: index, row: item }); setShowConfirmation(true) })}
                            >
                                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50' }} fontSize='large' />
                            </span>
                            <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                                onClick={() => handleCrossBtn(index)}
                                style={{ margin: '0px 4px', width: '25px', padding: '1px 1px', height: '24px', marginTop: '-4px', display: 'flex', justifyContent: 'center' }}
                                onKeyDown={(e) => navigation3(e, `aduExpiryDays-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
                            >
                                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red' }} fontSize="large" />
                            </span>
                        </div>}
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={sx.reportFlex} className="reportButton" style={{ padding: '16px 20px 2px 20px' }}>
                <Item sx={sx.itemsx} style={{ width: '17.5%' }}>
                    <DropDownOA
                        id='aduCategoryName'
                        label={bum.categoryName || 'Category Name'}
                        searchPlaceholder={bum.searchCategoryName || 'Search Category Name'}
                        defaultvalue={category?.name || ''}
                        value={category?.name || ''}
                        onSelect={(value) => {
                            setCategory(value)
                        }}
                        data={categoryList || []}
                        width={'100%'}
                        dataKey={`name`}
                        idKey={`id`}
                        prevId='aduCategoryName'
                        nextId='aduPolicyStatus'
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: '17.5%' }}>
                    <DropDownOA
                        id='aduPolicyStatus'
                        label={bum.policyStatus || 'Policy Status'}
                        searchPlaceholder={bum.searchCategoryName || 'Search Category Name'}
                        defaultvalue={policyStatus?.name || ''}
                        value={policyStatus?.name || ''}
                        onSelect={(value) => {
                            setPolicyStatus(value)
                        }}
                        data={statusList || []}
                        width={'100%'}
                        dataKey={`name`}
                        idKey={`id`}
                        prevId='aduCategoryName'
                        nextId='aduLoadBtn'
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='aduLoadBtn' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={() => { getTableData() }}
                        onKeyDown={(e) => {
                            navigation1(e, filteredData?.length > 0 ? 'editBtn-0' : 'aduCategoryName', 'aduPolicyStatus');
                        }}
                    >
                        {bum.load || 'LOAD'}
                    </Button>
                </Item>
            </Box>
            <Box sx={{ margin: '15px 20px 0px 20px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '70vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                            },
                        }}
                    >
                        <TableHead key='adu-tbl-header' style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow key='header-row'>
                                {headerColumnsUserAutoDeactivate.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444',
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow key='filter-row'>
                                {headerColumnsUserAutoDeactivate.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`}>
                                            <div key={`filter-div-${index}`} className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder={bum.contains || "Contains"}
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                    onKeyDown={(e) => navigation1(e, index === 6 ? `index-1` : `index-${index + 1}`, index === 1 ? `index-6` : `index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {filteredData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow key='empty-tbl-roe'>
                                        <TableCell key='no-result-cell' colSpan={14}>
                                            <div key='no-result-div'
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{bum.noResultsFoundPleaseRefineYourSearchParametersAndSearchAgain || 'No results found. Please refine your search parameters and search again.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : filteredData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {filteredData?.map((item, index) => (
                                    <InsideRowContent item={item} index={index} key={index} />
                                ))}
                                {/* ?.sort((a, b) => a.SubType.localeCompare(b.SubType)) */}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            {showConfirmation && <ShowAutoDeActivateUserConfirmation />}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getTableData() }} open={isSuccess} title={bum.policyStatusSavedSuccessfully || 'Policy Status Saved Successfully'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateAutoDeactivateUserData, getAutoDeactivateUserTblData, getADUCategoryData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(AutoDeactivateUser)
